import { PassengerPhone } from '../../data/models/passenger.model';
import { phoneUtils } from '../../services/phoneUtils';
import { useCommonTranslation } from '../useCommonTranslation';

export const usePassengerPhone = (
  phones: PassengerPhone[] | undefined,
  type: string,
): string => {
  const t = useCommonTranslation();
  let phone: PassengerPhone | undefined;
  if (phones && phones.length) {
    phone = phones.find((ph) => ph.phoneNumberTypeBC === type);
  }
  const formattedPhone = phoneUtils.formatPhone(phone);
  if (phone?.phoneExtension) {
    return `${formattedPhone} ${t('common.extension')} ${phone.phoneExtension}`;
  }
  return formattedPhone;
};
